"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerFooter = exports.useDrawerFooterCtx = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var rc_drawer_1 = tslib_1.__importDefault(require("rc-drawer"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var promise_1 = require("../utils/promise");
var hooks_1 = require("../utils/hooks");
var icons_1 = require("../icons");
var Button_1 = tslib_1.__importDefault(require("../Button"));
var Mask_1 = tslib_1.__importDefault(require("../internal/Mask"));
var PopupContainerProvider_1 = require("../PopupContainerProvider");
// 用于 Drawer 与 DrawerFooter 间交互的 context
var drawerFooterCtx = react_1.createContext({});
/** 获取用于自定义 Footer 实现的上下文信息 */
function useDrawerFooterCtx() {
    return react_1.useContext(drawerFooterCtx);
}
exports.useDrawerFooterCtx = useDrawerFooterCtx;
function Drawer(props) {
    var _this = this;
    var title = props.title, _a = props.width, width = _a === void 0 ? 480 : _a, visibleFromProps = props.visible, _b = props.footer, footer = _b === void 0 ? react_1.default.createElement(DrawerFooter, null) : _b, onOk = props.onOk, onCancel = props.onCancel, children = props.children, rootHtmlProps = props.rootHtmlProps, className = props.className, style = props.style, maskHtmlProps = props.maskHtmlProps, _c = props.autoDestroy, autoDestroy = _c === void 0 ? false : _c;
    var _d = hooks_1.useValue({ valueFromProps: visibleFromProps, defaultValue: true }), visible = _d.value, setVisible = _d.setValue;
    var prefix = ConfigProvider_1.usePrefix('drawer');
    var contentPrefix = utils_1.concat(prefix, 'content');
    var titlePrefix = utils_1.concat(contentPrefix, 'title');
    var bodyPrefix = utils_1.concat(contentPrefix, 'body');
    var footerPrefix = utils_1.concat(contentPrefix, 'footer');
    var popupContainerRef = react_1.useRef(null);
    var handleOk = react_1.useCallback(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (onOk === null || onOk === void 0 ? void 0 : onOk())];
                case 1:
                    _a.sent();
                    setVisible(false);
                    return [2 /*return*/];
            }
        });
    }); }, [onOk, setVisible]);
    var handleCancel = react_1.useCallback(function () {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        setVisible(false);
    }, [onCancel, setVisible]);
    var handleMaskClick = react_1.useCallback(function (e) {
        var _a;
        (_a = maskHtmlProps === null || maskHtmlProps === void 0 ? void 0 : maskHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(maskHtmlProps, e);
        if (e.defaultPrevented)
            return;
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        setVisible(false);
    }, [onCancel, setVisible, maskHtmlProps]);
    var footerCtxValue = react_1.useMemo(function () { return ({
        onOk: handleOk,
        onCancel: handleCancel
    }); }, [handleOk, handleCancel]);
    return (react_1.default.createElement(Mask_1.default, tslib_1.__assign({}, maskHtmlProps, { visible: visible, onClick: handleMaskClick, autoDestroy: autoDestroy }),
        react_1.default.createElement(rc_drawer_1.default, tslib_1.__assign({}, rootHtmlProps, { open: visible, showMask: false, prefixCls: prefix, level: null, handler: false, onClose: handleCancel, placement: "right", width: width, className: classnames_1.default(className, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className), style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }),
            react_1.default.createElement("div", { className: titlePrefix },
                title,
                react_1.default.createElement(icons_1.CloseIcon, { className: utils_1.concat(titlePrefix, 'close'), onClick: onCancel })),
            react_1.default.createElement("div", { className: bodyPrefix, ref: popupContainerRef },
                react_1.default.createElement(PopupContainerProvider_1.PopupContainerProvider, { containerRef: popupContainerRef }, children)),
            react_1.default.createElement("div", { className: footerPrefix },
                react_1.default.createElement(drawerFooterCtx.Provider, { value: footerCtxValue }, footer)))));
}
exports.default = Drawer;
function DrawerFooter(_a) {
    var _this = this;
    var okText = _a.okText, cancelText = _a.cancelText, _b = _a.okType, okType = _b === void 0 ? 'primary' : _b, _c = _a.cancelType, cancelType = _c === void 0 ? 'default' : _c, _d = _a.okLoading, okLoading = _d === void 0 ? false : _d, _e = _a.okButtonProps, okButtonProps = _e === void 0 ? {} : _e, _f = _a.cancelButtonProps, cancelButtonProps = _f === void 0 ? {} : _f;
    var langData = ConfigProvider_1.useLangData('modal');
    var _g = useDrawerFooterCtx(), onOk = _g.onOk, onCancel = _g.onCancel;
    var _h = hooks_1.useSafeState(false), loading = _h[0], setLoading = _h[1];
    var handleOk = react_1.useCallback(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var returns;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    returns = onOk === null || onOk === void 0 ? void 0 : onOk();
                    if (!promise_1.isPromise(returns)) return [3 /*break*/, 4];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, returns];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [onOk, setLoading]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, tslib_1.__assign({ type: okType, onClick: handleOk, loading: okLoading || loading }, okButtonProps), okText !== null && okText !== void 0 ? okText : langData.okText),
        react_1.default.createElement(Button_1.default, tslib_1.__assign({ onClick: onCancel, type: cancelType }, cancelButtonProps), cancelText !== null && cancelText !== void 0 ? cancelText : langData.cancelText)));
}
exports.DrawerFooter = DrawerFooter;
//# sourceMappingURL=index.js.map